import { Grid, LinearProgress, Typography } from "@mui/material";
import type { FC } from "react";
import { useProviderWithId } from "./useProviderWithId";

interface Props {
  readonly providerId: string;
  readonly enabled?: boolean;
}

const ProviderTermsAndConditionsContent: FC<Props> = ({ providerId, enabled = true }) => {
  const { provider, isLoading } = useProviderWithId(providerId, { enabled: enabled && !!providerId });

  return (
    <Grid size={12}>
      <Typography variant="subtitle2">Terms & conditions</Typography>
      {isLoading && <LinearProgress />}
      {provider?.termsAndConditions ? (
        <Typography sx={{ whiteSpace: "pre-wrap" }}>{provider.termsAndConditions}</Typography>
      ) : (
        !isLoading && <Typography>Brak regulaminu dla tego dostawcy.</Typography>
      )}
    </Grid>
  );
};

export default ProviderTermsAndConditionsContent;
